import React, {useState} from "react";
import {
    Avatar,
    Divider,
    Menu,
    IconButton,
    MenuItem,
    Typography,
    useTheme,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {GoogleLogout} from "react-google-login";
import {fbConfig} from "../utils/fbConfig";
import {version} from '../../package.json'
import {Brightness2, Brightness7} from '@material-ui/icons';
import {getBrowserFamily} from '../utils/browser';
import {logoutApp} from '../contexts/GlobalProviders';
import {withRouter} from 'react-router-dom';
import {useAuth} from 'reactfire';
import {withDialog} from '../contexts/DialogContext';
import {makeStyles} from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    avatar: {
        margin: 10,
        position: 'relative',
    },
    logoutMenuItem: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        '&:hover': {
            background: 'transparent'
        }
    },
    toggleButton: {
        color: 'white'
    }
}));

function RightMenuTopBar(props) {
    const auth = useAuth();
    const [anchorEl, setAnchorEl] = useState();
    const classes = useStyles();
    const theme = useTheme();

    const openMenu = (e) => {
        setAnchorEl(e.currentTarget)
    };

    const closeMenu = (e) => {
        setAnchorEl(false)
    };

    const toggleTheme = () => {
        theme.setCustomTheme(theme.palette.type === 'light' ? 'dark' : 'light')
    }
    return <>
        <Grid item xs={4} style={{display: "flex"}}>
            <Grid container alignItems={"center"}
                  justifyContent={"flex-end"}>

                <IconButton className={classes.toggleButton} onClick={toggleTheme}>
                    {
                        theme.palette.type === 'light' ? <Brightness2/> : <Brightness7/>
                    }
                </IconButton>
                <IconButton style={{padding: 0}} onClick={openMenu} aria-controls="simple-menu" aria-haspopup="true">
                    <Avatar alt={auth.currentUser?.displayName} src={auth.currentUser?.photoURL}
                            className={classes.avatar}/>
                </IconButton>
                <Menu open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement={{
                          vertical: 'bottom',
                          horizontal: 'left'
                      }}
                      keepMounted
                      id="simple-menu"
                      onClose={closeMenu}>
                        <Typography
                            variant="body2"
                            gutterBottom
                            style={{padding: '5px 10px'}}
                            align={'center'}>
                            {auth.currentUser?.displayName}
                        </Typography>
                        <Typography
                            variant="body2"
                            gutterBottom
                            style={{padding: '5px 10px'}}
                            align={'center'}>
                            v{version}
                        </Typography>
                        <MenuItem onClick={props.dialog.openShortcut}>
                            Atalhos
                        </MenuItem>
                        <Divider/>
                        <GoogleLogout
                            clientId={fbConfig.clientId}
                            onLogoutSuccess={() => logoutApp(props.history)}
                            cookiePolicy={'none'}
                            approvalPrompt="force"
                            responseType="id_token"
                            accessType="online"
                            isSignedIn
                            redirectUri={fbConfig.redirect_uri}
                            offline
                            prompt="consent"
                            uxMode={!getBrowserFamily('electron') ? 'popup' : 'redirect'}
                            fetchBasicProfile={true}
                            render={props2 =>
                                <MenuItem {...props2}
                                          onClick={() => {
                                              props2.onClick();
                                              logoutApp(props.history)
                                          }}
                                          className={classes.logoutMenuItem}>Logout</MenuItem>
                            }/>
                </Menu>
            </Grid>
        </Grid>
    </>;
}

export default withDialog(withRouter(RightMenuTopBar))
